import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { businessLoggerService } from './businessLoggerService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(businessLoggerService)
}
